export const SITE_NAME = "熊猫影院";
export const SITE_URL = "https://zenithcoin.asia";

export const NAV_LINKS = [
  { to: "/", label: "首页" },
  { to: "/category/movie", label: "电影" },
  { to: "/category/tv", label: "电视剧" },
  { to: "/about", label: "关于我们" },
];

export const LOGO_URL =
  "https://readdy.ai/api/search-image?query=Minimalist%20flat%20vector%20panda%20face%20logo%20mark%2C%20black%20and%20white%2C%20simple%20geometric%20shapes%2C%20cute%20calm%20expression%2C%20clean%20plain%20white%20background%2C%20brand%20icon%2C%20high%20contrast%2C%20centered%20composition&width=120&height=120&seq=panda-logo-mark&orientation=squarish";